import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { loadScript } from '../helpers/index';
import { VideoAction } from '../../../../constants/video_constants';

const UnwrappedWistiaVideo = ({ videoId, onVideoPlay }) => {
  useEffect(() => {
    const bindWistiaEmbed = () => {
      window.Wistia.embed(videoId, {
        version: 'v1',
        container: `wistia_${videoId}`,
        popover: true,
        popoverAnimateThumbnail: true,
        videoFoam: true,
      });
    };

    if (window.Wistia === undefined) {
      loadScript('//fast.wistia.com/static/concat/E-v1.js').then(bindWistiaEmbed);
    } else {
      bindWistiaEmbed();
    }
  }, [videoId]);

  return (
    <div
      className="wistia_responsive_padding"
      style={{ padding: '56.25% 0 0 0', position: 'relative' }}
      role="button"
      tabIndex="0"
      onClick={() => onVideoPlay(VideoAction.PLAY)}
      onKeyDown={() => onVideoPlay(VideoAction.PLAY)}
      aria-label="Play Video"
    >
      <div
        className="wistia_responsive_wrapper"
        style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}
      >
        <span
          id={`wistia_${videoId}`}
          className="wistia_embed"
          style={{ display: 'inline-block', height: '100%', width: '100%' }}
        />
      </div>
    </div>
  );
};

UnwrappedWistiaVideo.propTypes = {
  videoId: PropTypes.string.isRequired,
  onVideoPlay: PropTypes.func.isRequired,
};

export default UnwrappedWistiaVideo;
